import { createReducer } from 'typesafe-actions';
import { mainAction, mainState } from './types';

import {
  SET_SETTING_ID,
  GET_TOTAL_RECOMMEND,
  GET_TOTAL_RECOMMEND_ERROR,
  GET_TOTAL_RECOMMEND_SUCCESS,
  GET_WORD_CLOUD,
  GET_WORD_CLOUD_ERROR,
  GET_WORD_CLOUD_SUCCESS,
  GET_POPULAR_CONTENTS,
  GET_POPULAR_CONTENTS_ERROR,
  GET_POPULAR_CONTENTS_SUCCESS,
} from './actions';

const initialState: mainState = {
  error: null,
  loading: false,
  settingId: 0,
  totalRecommendData: null,
  popularContentsData: null,
  wordCloudData: null,
};

const reducer = createReducer<mainState, mainAction>(initialState, {
  [SET_SETTING_ID]: (state, action) => ({
    ...state,
    settingId: action.payload,
  }),

  [GET_TOTAL_RECOMMEND]: (state, action) => ({
    ...state,
    error: null,
    loading: true,
    totalRecommendData: null,
  }),
  [GET_TOTAL_RECOMMEND_SUCCESS]: (state, action) => ({
    ...state,
    error: null,
    loading: false,
    totalRecommendData: action.payload.payload,
  }),
  [GET_TOTAL_RECOMMEND_ERROR]: (state, action) => ({
    ...state,
    error: action.payload,
    loading: false,
    totalRecommendData: null,
  }),

  [GET_WORD_CLOUD]: (state, action) => ({
    ...state,
  }),
  [GET_WORD_CLOUD_SUCCESS]: (state, action) => ({
    ...state,
    wordCloudData: action.payload.payload || null,
  }),
  [GET_WORD_CLOUD_ERROR]: (state, action) => ({
    ...state,
    wordCloudData: null,
  }),

  [GET_POPULAR_CONTENTS]: (state, action) => ({
    ...state,
    popularContentsData: null,
  }),
  [GET_POPULAR_CONTENTS_SUCCESS]: (state, action) => ({
    ...state,
    popularContentsData: action.payload.payload,
  }),
  [GET_POPULAR_CONTENTS_ERROR]: (state, action) => ({
    ...state,
    popularContentsData: null,
  }),
});

export default reducer;
